import { showNotifications } from '@util/notifications';

export default function Notifications() {
  showNotifications();
  return null;
}
